import { useSelector } from "react-redux";
import RelatedBlogItem from "./RelatedBlogItem";

export default function RelatedBlog() {
    const { isLoading, blogs, isError, error } = useSelector((state) => state.relatedBlogs);

    return (
        <aside>
            <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts"> Related Posts </h4>
            <div className="space-y-4 related-post-container">
                {isLoading && <div> Loading... </div>}
                {isError && <div> {error} </div>}

                {!isLoading && !isError && !blogs.length && (<div>No Related Blog Found</div>)}

                {!isLoading && !isError && blogs.map((blog) => <RelatedBlogItem key={blog.id} blog={blog} />)}
            </div>
        </aside>
    );
}
